import { Routes, Route } from 'react-router-dom';
import AssetsTabs from '../AssetsIntelligence/AssetsTabs';
import CloseCompliance from '../CloseCompliance/CloseCompliance';
import CloudDiscovery from '../CloudDiscovery/CloudDiscoveryTab';
import CloudProductionTracking from '../CloudProductionTracking/CPT';
import ControlCenter from '../ControlCenter/ControlCenter';
import Dig from '../Dig/Dig';
import ElementAlias from '../Settings/ElementAlias/ElementAlias';
import EventMaterialType from '../Settings/EventOperationsTabs/EventMaterialType';
import EventStatus from '../Settings/EventOperationsTabs/EventStatus';
import EventType from '../Settings/EventOperationsTabs/EventType';
import Priority from '../Settings/KanBan/Priority';
import SwimLine from '../Settings/KanBan/SwimLine';
import ApplicationComponent from '../Settings/Security/ApplicationComponent';
import AUM from '../Settings/Security/AUM';
import CompanyDepartment from '../Settings/Security/CompanyDepartment';
import CompanySites from '../Settings/Security/CompanySites';
import SecurityRoles from '../Settings/Security/SecurityRoles';
import SystemConfigration from '../Settings/Security/SystemConfigration';
import Settings from '../Settings/Settings';
import TableRoster from '../Settings/TableRoster';
import TableRosterTemplate from '../Settings/TableRosterTemplates';
import Positions from '../Settings/Training/Positions';
import TrainingCategories from '../Settings/Training/TrainingCategories';
import TrainingItems from '../Settings/Training/TrainingItems';
import AssetType from '../Settings/Workbench/AssetType';
import Departments from '../Settings/Workbench/Department';
import EquipmentDReason from '../Settings/Workbench/EquipmentDReason';
import Hseq from '../Settings/Workbench/Hseq';
import Incidents from '../Settings/Workbench/Incidents';
import Marea from '../Settings/Workbench/Marea';
import MovementsType from '../Settings/Workbench/MovementsType';
import OperationReasons from '../Settings/Workbench/OperationReasons';
import ShiftWorkbenchStatus from '../Settings/Workbench/ShiftWorkbenchStatus';
import Sites from '../Settings/Workbench/Sites';
import SourceLocation from '../Settings/Workbench/SourceLocation';
import Supervisor from '../Settings/Workbench/Supervisor';
import TargetLocation from '../Settings/Workbench/TargetLocation';
import TruckFactor from '../Settings/Workbench/TruckFactor';
import WorkbenchTemplate from '../Settings/Workbench/WorkbenchTemplates';
import TradePerson from '../TradePerson/TradePerson';
import EventResources from '../Settings/EventOperationsTabs/EventResources/EventResources';
import CompanyPortoilo from '../Settings/Security/CampanyPortfolio/CampanyPortfolio';
import CloudPlanner from '../CloudPlaner/TabBar';
import TradePlaner from '../TradePlanner/TradePlannerSplitter';
import MaintanceStrategiesTabs from '../MaintanceStrategies/MaintanceStrategiesTabs';
import ShiftWorkbenchTabs from '../ShiftWorkbench/TabTop/ShiftWorkbenchTabs';
import SchedulerTabBar from '../CloudScheduler/SchedulerTabBar';
import AssetCostModelTabs from '../AssetCostModel/AssetCostModelTabs';
import WorkordersFilterTabs from '../Settings/GlobalFilter/WorkordersFilter/WorkordersFilterTabs';
import WorkrequestFilterTabs from '../Settings/GlobalFilter/WorkrequestFilter/WorkrequestFilterTabs';
import Scheduler from '../Settings/Scheduler/Scheduler';
import { useSelector } from 'react-redux';
import NoConnectin from '../NoConnection/NoConnectin';
import { memo, useEffect, useState } from 'react';
import CloudScheduler from '../CloudScheduler/CloudScheduler';
import SchedulerExeptions from '../Settings/Scheduler/SchedulerExeptions';
import SupervisorControlModuleSettings from '../Settings/Scheduler/SupervisorControlModuleSettings';
import OperationTemplate from '../Settings/OperationTemplate/OperationTemplate';
import OperationFilterTabs from '../Settings/GlobalFilter/OperationFilter/OperationFilterTabs';
import TradePlannerNoteType from '../Settings/GlobalFilter/TradePlannerType/TradePlannerNoteType';
import SystemSettings from '../Settings/Security/SystemSettings';
import Reorder from '../Settings/KanBan/Reorder';
import Preferences from '../Settings/Preferences/Preferences';
import CloudExecution from '../CloudExecution/CloudExecution';
import SystemSettingsTabs from "../Settings/Security/SystemSettingsTabs";

function RouterCustom() {
  const { isConnected } = useSelector((state: any) => state.conn);
  const [CurrentPath, setCurrentPath] = useState<string | undefined>(undefined);
  useEffect(() => {
    if (isConnected) {
      setCurrentPath(undefined);
    } else {
      setCurrentPath('/no-connection');
    }
  }, [isConnected]);

  
  return (
      <Routes location={CurrentPath}>
        <Route path='/' element={<ControlCenter />} />
        <Route path='/clouddiscovery' element={<CloudDiscovery />} />
        <Route path='/cloudscheduler' element={<SchedulerTabBar />} />
        <Route path='/cloudplanner' element={<CloudPlanner />} />
        <Route path='/cloudexecution' element={<CloudExecution />} />
        <Route path='/closecompliance' element={<CloseCompliance />} />
        <Route path='/tradesperson' element={<TradePerson />} />
        <Route path='/tradeplanner' element={<TradePlaner />} />
        <Route path='/assetintelligence' element={<AssetsTabs />} />
        <Route
          path='/cloudproductiontracking'
          element={<CloudProductionTracking />}
        />
        <Route path='/shiftworkbench' element={<ShiftWorkbenchTabs />} />
        <Route path='/mntStrategies' element={<MaintanceStrategiesTabs />} />
        <Route path='/assetCModel' element={<AssetCostModelTabs />} />
        <Route path='/dig' element={<Dig />} />
        <Route
          path='/superVisorControlHub'
          element={<CloudScheduler isSuperVisor={true} />}
        />
        {!isConnected ? (
          <Route path='/no-connection' element={<NoConnectin />} />
        ) : null}
        <Route path='/settings/' element={<Settings />}>
          <Route path='eventStatus' element={<EventStatus />} />
          <Route path='eventType' element={<EventType />} />
          <Route path='eventMaterialType' element={<EventMaterialType />} />
          <Route path='eventResources' element={<EventResources />} />
          <Route path='shiftElement' element={<TableRoster />} />
          <Route path='shiftTemplate' element={<TableRosterTemplate />} />
          <Route path='elementAlias' element={<ElementAlias />} />
          <Route path='preferences' element={<Preferences />} />
          <Route path='moduleConf/shiftWorkbench/hseq' element={<Hseq />} />
          <Route
            path='Scheduling/general/schedulingPercentage'
            element={<Scheduler />}
          />
          <Route
            path='Scheduling/general/exeptions'
            element={<SchedulerExeptions />}
          />
          <Route
            path='Scheduling/general/max-scheduling-period'
            element={<SupervisorControlModuleSettings />}
          />
          <Route
            path='moduleConf/shiftWorkbench/incidentType'
            element={<Incidents />}
          />
          <Route
            path='moduleConf/shiftWorkbench/equipmentDReasons'
            element={<EquipmentDReason />}
          />
          <Route path='applicationComponent' element={<ApplicationComponent />} />
          <Route path='systemSettings' element={<SystemSettings />} />
          <Route
            path='applicationUserManagement'
            element={
              <AUM GridHeight={'73vh'} change={() => { }} triggered={() => { }} />
            }
          />
          <Route path='companyPortolio' element={<CompanyPortoilo />} />
          <Route path='companySite' element={<CompanySites />} />
          <Route path='companyDepartments' element={<CompanyDepartment />} />
          <Route path='securityRols' element={<SecurityRoles />} />
          <Route path='systemConfigration' element={<SystemConfigration />} />
          <Route path='kanbanSettings' element={<Priority />} />
          <Route path='swimlineSettings' element={<SwimLine />} />
          <Route path='/settings/planner/Reorder' element={<Reorder />} />
          <Route path='planner/filter' element={<TradePlannerNoteType />} />
          <Route
            path='moduleConf/shiftWorkbench/departments'
            element={<Departments />}
          />
          <Route
            path='moduleConf/shiftWorkbench/workbenchTemplate'
            element={<WorkbenchTemplate />}
          />
          <Route
            path='moduleConf/shiftWorkbench/ShiftWorkbenchStatus'
            element={<ShiftWorkbenchStatus />}
          />
          <Route path='moduleConf/shiftWorkbench/sites' element={<Sites />} />
          <Route
            path='moduleConf/shiftWorkbench/trackfactor'
            element={<TruckFactor />}
          />
          <Route
            path='moduleConf/shiftWorkbench/movementstype'
            element={<MovementsType />}
          />
          <Route
            path='moduleConf/shiftWorkbench/sourcelocation'
            element={<SourceLocation />}
          />
          <Route
            path='moduleConf/shiftWorkbench/targetlocation'
            element={<TargetLocation />}
          />
          <Route
            path='moduleConf/shiftWorkbench/miningarea'
            element={<Marea />}
          />
          <Route
            path='moduleConf/shiftWorkbench/assetType'
            element={<AssetType />}
          />
          <Route
            path='moduleConf/shiftWorkbench/supervisor'
            element={<Supervisor />}
          />
          <Route
            path='moduleConf/shiftWorkbench/reason'
            element={<OperationReasons />}
          />
          <Route path='training/categories' element={<TrainingCategories />} />
          <Route path='training/items' element={<TrainingItems />} />
          <Route path='training/positions' element={<Positions />} />
          <Route
            path='/settings/operationTemplates'
            element={<OperationTemplate />}
          />
          <Route
            path='/settings/globalFilters/workorders'
            element={<WorkordersFilterTabs />}
          />
          <Route
            path='/settings/globalFilters/operations'
            element={<OperationFilterTabs />}
          />
            <Route
                path='/settings/systemSettings/'
                element={<SystemSettingsTabs />}
            />
          <Route
            path='/settings/globalFilters/workrequest'
            element={<WorkrequestFilterTabs />}
          />
        </Route>
      </Routes>
  );
}

export default memo(RouterCustom);
